var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.72 128.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16074",
    d: "m75.75,41.16c6.28,6.28,6.28,16.47,0,22.76-6.28,6.28-16.47,6.28-22.76,0-6.28-6.28-6.28-16.47,0-22.76,0,0,0,0,0,0,6.28-6.28,16.47-6.28,22.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16075",
    d: "m125.84,52.07l-11.69-2.73h-.45c-.95-3.16-2.22-6.21-3.79-9.11l.3-.3,6.38-10.17c.88-1.35.82-3.11-.15-4.4l-1.97-1.97-10.93-10.93c-1.27-1.04-3.07-1.1-4.4-.15l-10.17,6.38c-.15.15-.3.15-.3.3-2.9-1.58-5.95-2.85-9.11-3.8v-.45l-2.74-11.68c-.34-1.63-1.69-2.85-3.34-3.04h-18.06c-1.63.23-2.96,1.43-3.34,3.04l-2.73,11.69v.45c-3.16.95-6.21,2.22-9.11,3.8l-.3-.3-10.17-6.38c-1.35-.88-3.11-.82-4.4.15l-1.97,1.82-10.93,10.93c-1.04,1.27-1.1,3.07-.15,4.4l6.38,10.17c.15.15.15.3.3.3-1.58,2.9-2.85,5.95-3.8,9.11h-.45l-11.68,2.74c-1.63.34-2.85,1.69-3.04,3.34v18.06c.23,1.63,1.43,2.96,3.04,3.34l11.69,2.73h.46c.95,3.16,2.22,6.21,3.8,9.11l-.3.3-6.38,10.17c-.88,1.35-.82,3.11.15,4.4,1.06,1.21,1.82,1.97,1.82,1.97l10.93,10.93c1.27,1.04,3.07,1.1,4.4.15l10.17-6.38.15-.15q.15,0,.15-.15c2.9,1.57,5.95,2.85,9.11,3.79v.45l2.73,11.69c.16.55.42,1.06.76,1.52.55.91,1.52,1.48,2.58,1.52h18.07c1.05-.07,2.01-.63,2.58-1.52.34-.46.6-.97.76-1.52l2.73-11.69v-.46c3.16-.95,6.21-2.22,9.11-3.79l.15.15.15.15,10.17,6.38c1.35.88,3.11.82,4.4-.15l1.97-1.82,10.93-10.93c1.04-1.27,1.1-3.07.15-4.4l-6.38-10.17c-.15-.15-.15-.3-.3-.3,1.57-2.9,2.85-5.95,3.79-9.11h.45l11.69-2.73c1.63-.34,2.85-1.69,3.04-3.34v-18.07c-.17-1.61-1.32-2.94-2.88-3.34m-37.64,38.86c-2.6-13.16-15.38-21.72-28.55-19.12-9.66,1.91-17.21,9.46-19.12,19.12-14.66-13.16-15.87-35.72-2.71-50.38,13.16-14.66,35.72-15.87,50.38-2.71,14.66,13.16,15.87,35.72,2.71,50.38-.85.95-1.76,1.86-2.71,2.71"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.c9c867d3e67e05fc71edb42ccfe27883.svg";
export { ForwardRef as ReactComponent };